import {Slider, styled} from "@mui/material";

const StyledSlider = styled(Slider)({
    color: '#28ade0',
    height: 8,
    '& .MuiSlider-thumb': {
        height: '1.5em',
        width: '1.5em',
        backgroundColor: '#fff',
        border: '2px solid currentColor',
        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'inherit',
        },
        '&:before': {
            display: 'none',
        },
    },
    '& .MuiSlider-markLabel': {
        fontSize: '1em',
        fontWeight: 'bold',
    },
    '& .MuiSlider-valueLabel': {
        lineHeight: 1.2,
        fontSize: '1em',
        background: 'unset',
        padding: 0,
        width: '2em',
        height: '2em',
        backgroundColor: '#28ade0',
        '&:before': { display: 'none' },
    },
});

export default function SliderComponent(props) {
    return <StyledSlider {...props}/>
}